import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { fuseAnimations } from '@fuse/animations';
import { Subject } from 'rxjs';

/// idiomas
import {TranslateService} from '@ngx-translate/core';
import { lang_certificar } from 'app/idiomas/i18n/certificar/certificar.lang';
import { lang_modales } from 'app/idiomas/i18n/modales/modales.lang';
import { lang_fileman } from 'app/idiomas/i18n/fileMan/filemanager.lang';
import { lang_perfiles } from 'app/idiomas/i18n/perfiles/perfiles.lang';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';

import { AuthService } from 'app/auth/auth.service';
import { CloudService } from './cloud.service';
import * as backInter from 'app/auth/auth-data.model';
import Swal from 'sweetalert2';
import { Colaboradores35Service } from 'app/main/wizard-n35/services/colaboradores35.service';
import { WizardService } from 'app/main/wizard-cgo/services/wizard.service';
@Component({
  selector: 'app-cloud',
  templateUrl: './cloud.component.html',
  styleUrls: ['./cloud.component.scss'],
  animations   : fuseAnimations
})
export class CloudODSComponent implements OnInit {

  idEmpresa: string;
  idProducto: string;
  datosEmpresa = {
    idEmpresa: '',
    idProducto: ''
  };

  productoCertificar: backInter.prodNorma35;
  //boolean cargando
  cargando = true;
  puedeCargar = false;
  listadoGPTW = false;

  direccionActual: string;
  idCarpetaActual: string;

  numArchivos = new Array(10);

  files: any[] = [];

  guardandoArchivo = false;

  listaArchivosEmpresa: backInter.getArchivosEmpresa;
  listaArchivosInstituto: backInter.getArchivosInstituto;

  eventsSubject: Subject<any> = new Subject<any>();

  nombreEmpresa: string;

  progresoCarga: number = 0;

  versionCloudNueva: boolean;
  enRaiz: boolean;

  constructor(
    private _fuseTranslationLoaderService: FuseTranslationLoaderService,
    private translateSrv: TranslateService,
    private cloudService: CloudService,
    private authService:AuthService,
    private colaboradoresService: Colaboradores35Service,
    private activatedRoute : ActivatedRoute,
    private router: Router,
    private wizardService: WizardService,
    private location: Location
  ) {
    lang_certificar.forEach((locale) => {
        this._fuseTranslationLoaderService.loadTranslations(locale);
    });
    lang_fileman.forEach((locale) => {
        this._fuseTranslationLoaderService.loadTranslations(locale);
    });
    lang_perfiles.forEach((locale) => {
        this._fuseTranslationLoaderService.loadTranslations(locale);
    });
    // this.obtieneCertificarActual(); // Se ocupa para crear carpetas de nom
    this.activatedRoute.params.subscribe(params => {
      //console.log('llego el parametro');
      console.log(params);
      this.idEmpresa = params.id;
      this.idProducto = params.idprod;
      this.datosEmpresa.idEmpresa = params.id;
      this.datosEmpresa.idProducto = params.idprod;
    });
  }

  ngOnInit() {
    this.wizardService.getInfoEmpresa(this.datosEmpresa.idEmpresa).subscribe((data:backInter.infoEmpresa) => {
      this.nombreEmpresa = data.data.nombreEmpresa;
    });
  }

  regresarDetail(){
    // this.router.navigate(['/companies/detail',this.idEmpresa]);
    this.location.back();
  }

  setDireccionActual(direccion:string){
    this.direccionActual = direccion;
  }
  setIdCarpetaActual(id:string){
    this.idCarpetaActual = id;
  }

  uploadFile(event) {
    for (let index = 0; index < event.length; index++) {
      const element = event[index];
      this.guardandoArchivo = true;

      const reader: FileReader = new FileReader();
      let archivo = element;
      if(this.versionCloudNueva){
        this.cargaArchivo_cloudNuevo(archivo);
      } else{
        this.cargaArchivo_cloudAnterior(archivo);
      }
    }
  }

  ////LEER XLSM
  onFileChange(evt: any) {
    this.guardandoArchivo = true;
		/* wire up file reader */
		const target: DataTransfer = <DataTransfer>(evt.target);
		if (target.files.length !== 1) throw new Error('Cannot use multiple files');

    const reader: FileReader = new FileReader();
    let archivo = evt.target.files[0];

    if(this.versionCloudNueva){
      this.cargaArchivo_cloudNuevo(archivo);
    } else{
      this.cargaArchivo_cloudAnterior(archivo);
    }

    evt.target.value = '';

	}

  cargaArchivo_cloudAnterior(archivo: any){
    let fd = new FormData();
    fd.append('file',archivo, archivo.name);
    fd.append('ubicacion',this.direccionActual);
    fd.append('empresaId',this.idEmpresa);
    if(this.idCarpetaActual){
      fd.append('carpetaId',this.idCarpetaActual);
    }
    // console.log(...fd);
    // new Response(fd).text().then(console.log);

    this.cloudService.guardaArchivo(fd).subscribe((res) => {
        // console.log(res)
        if(res.status){
          if(res.status == "progress"){
            this.progresoCarga = res.message;
          }
        }
        else if(res.success){
          this.mensajeSwal('FILEMANAGER.MENSAJES.CARGAOK',1);
          this.emitEventToChild();
          this.guardandoArchivo = false;
          this.progresoCarga = 0;
        }
        else{
          if(res.message == 'archivo_save_1'){
            this.mensajeSwal('FILEMANAGER.MENSAJES.CARGAREP',3);
            this.guardandoArchivo = false;
            this.progresoCarga = 0;
          }
        }
      },
      (err) => console.log(err)
    );
  }
  cargaArchivo_cloudNuevo(archivo: any){
    let fd = new FormData();
    fd.append('File',archivo, archivo.name);
    fd.append('path',this.direccionActual);
    fd.append('mkdir','false');
    fd.append('copyifexists','true');
    fd.append('overwrite','false');

    this.cloudService.guardaArchivo_nuevo(fd).subscribe((res) => {
        // console.log(res)
        if(res.status){
          if(res.status == "progress"){
            this.progresoCarga = res.message;
          }
        }
        else if(res.success){
          this.mensajeSwal('FILEMANAGER.MENSAJES.CARGAOK',1);
          this.emitEventToChild();
          this.guardandoArchivo = false;
          this.progresoCarga = 0;
        }
        else{
          if(res.message == 'File already exists [No overwrite]'){
            this.mensajeSwal('FILEMANAGER.MENSAJES.CARGAREP',3);
            this.guardandoArchivo = false;
            this.progresoCarga = 0;
          }
        }
      },
      (err) => console.log(err)
    );
  }

  emitEventToChild() {
    this.eventsSubject.next(true);
  }

  mensajeSwal(mensaje:string, tipoMsg:number){
    let texto = '';
    this.translateSrv.get(mensaje).subscribe((res: string) => { texto = res; });
    let tipo: any;
    let rspSi = 'MODALES.ACCIONES.aceptar';
    this.translateSrv.get(rspSi).subscribe((res: string) => { rspSi = res; });
    switch(tipoMsg){
      case 1: tipo = 'success'; break;
      case 2: tipo = 'warning'; break;
      case 3: tipo = 'error'; break;
    }
    Swal.fire({
      title: texto,
      icon: tipo,
      confirmButtonText: rspSi,
      confirmButtonColor: '#e40601'
    });
  }

  obtieneCertificarActual(){
    this.colaboradoresService.getProdCertAct().subscribe((data:backInter.infoProductos) => {
      console.log("Data certifiar");
      console.log(data);
      let prodsCertificar:backInter.prodNorma35[] = data.productosNorma35;
      console.log(prodsCertificar);
      /*if(prodsCertificar.length==0){
        localStorage.setItem('tipoNorma35', '4');
      }*/
      var BreakException = {};
      /*try {
          prodsCertificar.forEach( (producto) => {
            if(producto.completoNorma35 === 1){
              this.productoCertificar = producto;
               console.log(this.productoCertificar);
               if(this.productoCertificar.tipo == 2){
                localStorage.setItem('tipoNorma35', '2');
               }else{
                localStorage.setItem('tipoNorma35', '1');
               }

              throw BreakException;
            }
          });
      } catch (e) {
        if (e !== BreakException) throw e;
      };*/
    }, error  => {
      console.log("error al recuperar certificar vigente");
    });
  }

}
